import * as React from "react";
export default class StoreHours extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let Hours = {
            "Monday": {
                Open: this.props.supplier.MondayOpen,
                Close: this.props.supplier.MondayClose
            },
            "Tuesday": {
                Open: this.props.supplier.TuesdayOpen,
                Close: this.props.supplier.TuesdayClose
            },
            "Wednesday": {
                Open: this.props.supplier.WednesdayOpen,
                Close: this.props.supplier.WednesdayClose
            },
            "Thursday": {
                Open: this.props.supplier.ThursdayOpen,
                Close: this.props.supplier.ThursdayClose
            },
            "Friday": {
                Open: this.props.supplier.FridayOpen,
                Close: this.props.supplier.FridayClose
            },
            "Saturday": {
                Open: this.props.supplier.SaturdayOpen,
                Close: this.props.supplier.SaturdayClose
            },
            "Sunday": {
                Open: this.props.supplier.SundayOpen,
                Close: this.props.supplier.SundayClose
            }
        };
        return React.createElement("div", { className: "hours" }, Object.keys(Hours).map((key, index) => {
            return React.createElement("div", { className: "row", key: key },
                React.createElement("span", { className: "day" }, key),
                React.createElement("span", { className: "time" }, Hours[key].Open && Hours[key].Close ? Hours[key].Open + " - " + Hours[key].Close : "No Info"));
        }));
    }
}
//# sourceMappingURL=store-hours.js.map